import { hasSessionStorage } from './ssr';

const SESSION_KEY = '@entourage/ecs-telemetry:sessionId';

export const generateEventId = (): string => globalThis.crypto.randomUUID();

export const getOrCreateSessionId = (): string => {
  if (!hasSessionStorage()) return 'ssr-no-session';
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = globalThis.crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'ssr-no-session';
  }
};

export const nowIso = (): string => new Date().toISOString();
